var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-announcement"},[(_vm.message)?_c('AulaAlert',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }